import React from 'react';
import PropTypes from 'prop-types';
import { Box, Drawer } from '@mui/material';
import { refShape } from '../shapes';
import DetailDrawerHeaderBar from './DetailDrawerHeaderBar';
import DetailDrawerBody from './DetailDrawerBody';

// Side drawer that opens when a candidate row is clicked.
const BreakoutDetailDrawer = ({
  detailDrawer,
  onClose,
  isCompact,
  drawerExporting,
  onExport,
  drawerRef,
  bodyRef,
  t,
  language,
  locale,
  detailHistory,
  detailHistoryLoading,
  getMetadataLabel,
}) => (
  <Drawer
    anchor="right"
    open={!!detailDrawer}
    onClose={onClose}
    slotProps={{
      paper: {
        sx: {
          width: { xs: '100%', sm: 460 },
          p: 0,
          bgcolor: { xs: '#f8fafc', sm: '#fff' },
        },
      },
    }}
  >
    <Box
      ref={drawerRef}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        bgcolor: { xs: '#f8fafc', sm: '#fff' },
      }}
    >
      <DetailDrawerHeaderBar
        detailDrawer={detailDrawer}
        isCompact={isCompact}
        drawerExporting={drawerExporting}
        onExport={onExport}
        onClose={onClose}
        t={t}
        language={language}
      />
      <Box
        ref={bodyRef}
        sx={{
          p: { xs: 1.5, sm: 2 },
          overflowY: 'auto',
          pb: { xs: 3, sm: 2 },
          flex: 1,
        }}
      >
        <DetailDrawerBody
          detailDrawer={detailDrawer}
          t={t}
          language={language}
          locale={locale}
          detailHistory={detailHistory}
          detailHistoryLoading={detailHistoryLoading}
          getMetadataLabel={getMetadataLabel}
        />
      </Box>
    </Box>
  </Drawer>
);

BreakoutDetailDrawer.propTypes = {
  detailDrawer: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onClose: PropTypes.func.isRequired,
  isCompact: PropTypes.bool,
  drawerExporting: PropTypes.bool,
  onExport: PropTypes.func.isRequired,
  drawerRef: refShape,
  bodyRef: refShape,
  t: PropTypes.func.isRequired,
  language: PropTypes.string,
  locale: PropTypes.string,
  detailHistory: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  detailHistoryLoading: PropTypes.bool,
  getMetadataLabel: PropTypes.func.isRequired,
};

BreakoutDetailDrawer.defaultProps = {
  detailDrawer: null,
  isCompact: false,
  drawerExporting: false,
  drawerRef: null,
  bodyRef: null,
  language: 'en',
  locale: 'en-US',
  detailHistory: null,
  detailHistoryLoading: false,
};

export default BreakoutDetailDrawer;
